import customer from "../images/customer.png";
import Vendor from "../images/man.png";
import cash from "../images/dollar.png";
import sales from "../images/sales.png";
import purchase from "../images/purchase.png";
import pdc from "../images/wallet.png";
import bank from "../images/bank.png";
import payments from "../images/payment.png";
import expense from "../images/budget.png";
import profit from "../images/profit-i.png";
import w from "../images/w-i.png";
import d from "../images/d-i.png";


import salesBg from "../images/increase.png";
import purchaseBg from "../images/cart.png";
import paymentBg from "../images/pBg.png";
import walletBg from "../images/wBg.png";
import customerBg from "../images/bBg.png";
import vendorBg from "../images/team.png";
import bankBg from "../images/mBg.png";
import cashBg from "../images/cash-flow.png";
import expenseBg from "../images/budgget.png";
import profitBg from "../images/profits-b.png";
import wBg from "../images/w-b.png";
import dBg from "../images/d-b.png";

export const currencyDisplay = (amountVal) => {
  const clientData = JSON.parse(
    sessionStorage.getItem("clientSettings") || "null",
  );

  if (clientData) {
    let amount = 0;
    switch (clientData?.currencyDecimal) {
      case "N2":
        amount = amountVal.toFixed(2);
        break;
      case "N3":
        amount = amountVal.toFixed(3);
        break;
      case "N1":
        amount = amountVal.toFixed(1);
        break;
      default:
        amount = parseFloat(amountVal);
    }
    return amount;
  }

  return amountVal;
};

export const getGrowthIconClass = (iconCode) => {
  switch (iconCode) {
    case 0:
      return "ri-arrow-right-line";
    case -1:
      return "ri-arrow-left-down-line";
    case 1:
      return "ri-arrow-right-up-line";
    default:
      return "ri-arrow-right-line";
  }
};

// Function to return appropriate card icon based on type
export const getCardIcon = (type) => {
  switch (type) {
    case "Sales":
      return <img src={sales} alt="Sales" />;
    case "Profit":
      return <img src={profit} alt="Profit" />;
      case "Wholesale":
      return <img src={w} alt="Wholesale" />;
    case "Purchase":
      return <img src={purchase} alt="Purchase" />;
    case "Payments":
      return <img src={payments} alt="Payments" />;
    case "Expense":
      return <img src={expense} alt="Expense" />;
    case "PDC Payable":
      return <img src={pdc} alt="PDC" />;
    case "Customer Balance":
      return <img src={customer} alt="Customer Balance" />;
    case "Vendor Balance":
      return <img src={Vendor} alt="Vendor Balance" />;
    case "Bank":
      return <img src={bank} alt="Bank" />;
    case "Cash":
      return <img src={cash} alt="Cash" />;
    default:
      return <img src={d} alt="Default" />;
  }
};

export const getCardIconForPayment = (type) => {
  switch (type) {
    case "Sales":
      return <img src={sales} alt="Sales" />;
    case "Purchase":
      return <img src={purchase} alt="Purchase" />;
    case "Payments":
      return <img src={payments} alt="Payments" />;
    case "Expense":
      return <img src={expense} alt="Expense" />;
    case "PDC Payable":
      return <img src={pdc} alt="PDC" />;
    case "Customer Balance":
      return <img src={customer} alt="Customer Balance" />;
    case "Vendor Balance":
      return <img src={Vendor} alt="Vendor Balance" />;
    case "CreditCard":
      return <img src={bank} alt="CreditCard" />;
    case "Cash":
      return <img src={cash} alt="Cash" />;
    default:
      return <img src={d} alt="Default" />;
  }
};

export const getCardIconBg = (type) => {
  switch (type) {
    case "Sales":
      return <img src={salesBg} alt="Sales" />;
    case "Profit":
      return <img src={profitBg} alt="Profit" />;
       case "Wholesale":
      return <img src={wBg} alt="Wholesale" />;
    case "Purchase":
      return <img src={purchaseBg} alt="Purchase" />;
    case "Payments":
      return <img src={paymentBg} alt="Payments" />;
    case "Expense":
      return <img src={expenseBg} alt="Expense" />;
    case "PDC Payable":
      return <img src={walletBg} alt="PDC" />;
    case "Customer Balance":
      return <img src={customerBg} alt="Customer Balance" />;
    case "Vendor Balance":
      return <img src={vendorBg} alt="Vendor Balance" />;
    case "Bank":
      return <img src={bankBg} alt="Bank" />;
    case "Cash":
      return <img src={cashBg} alt="Cash" />;
    default:
      return <img src={dBg} alt="Default" />;
  }
};

export const getCardIconBgForPayment = (type) => {
  switch (type) {
    case "Sales":
      return <img src={salesBg} alt="Sales" />;
    case "Purchase":
      return <img src={purchaseBg} alt="Purchase" />;
    case "Payments":
      return <img src={paymentBg} alt="Payments" />;
    case "Expense":
      return <img src={expenseBg} alt="Expense" />;
    case "PDC Payable":
      return <img src={walletBg} alt="PDC" />;
    case "Customer Balance":
      return <img src={customerBg} alt="Customer Balance" />;
    case "Vendor Balance":
      return <img src={vendorBg} alt="Vendor Balance" />;
    case "CreditCard":
      return <img src={bankBg} alt="CreditCard" />;
    case "Cash":
      return <img src={cashBg} alt="Cash" />;
    default:
      return <img src={dBg} alt="Default" />;
  }
};

export const getCardBg = (type) => {
  switch (type) {
    case "Sales":
      return "bg-indigo-400";

    case "Profit":
      return "bg-[#E4D329]"; // Bright lime

    case "Wholesale":
      return "bg-[#F375C2]"; 

    case "Purchase":
      return "bg-red-400";

    case "Payments":
      return "bg-green-500";

    case "Expense":
      return "bg-[#6B3F69]";

    case "PDC Payable":
      return "bg-yellow-500";

    case "Customer Balance":
      return "bg-purple-400";

    case "Vendor Balance":
      return "bg-[#9F8383]";

    case "Bank":
      return "bg-cyan-500";

    case "Cash":
      return "bg-[#FA812F]";

    default:
      return "bg-[#67C090]"; 
  }
};

export const getCardBgForPayment = (type) => {
  switch (type) {
    case "Sales":
      return "bg-indigo-400";
    case "Profit":
      return "bg-indigo-400";

    case "Purchase":
      return "bg-red-400";

    case "Payments":
      return "bg-green-500";

    case "Expense":
      return "bg-[#6B3F69]";

    case "PDC Payable":
      return "bg-yellow-500";

    case "Customer Balance":
      return "bg-purple-400";

    case "Vendor Balance":
      return "bg-[#9F8383]";

    case "CreditCard":
      return "bg-cyan-500";

    case "Cash":
      return "bg-[#FA812F]";

    default:
      return "bg-[#67C090]";
  }
};
